import includes from 'lodash.includes';
import pick from 'lodash.pick';
import Role from 'bunsen/models/identity/Role';

import User from '../global/models/User';

const { TRADE_STATUSES } = User;
const tradeStatusesThatCanApplyForTrade = pick(TRADE_STATUSES, ['N_A', 'SUSPECTED']);

const updateUserTradeStatusOptions = (statusName) => ({
    userStatus: {
        apiType: 'roleStatus',
        name: statusName
    }
});

export const currentUser = () => User.getCurrentUser();

export const userLoggedIn = () => User.loggedIn();

const saveTradeStatus = (statusName) => () => {
    if (userLoggedIn()) {
        const role = new Role({ name: User.BUYER_TRADE, ...updateUserTradeStatusOptions(statusName) });
        currentUser().get('roles').add(role);
        role.saveRoleForUser();
    }
};

export const currentUserTradeStatus = () => {
    return User.loggedIn() ? currentUser().getTradeStatus() : null;
};

export const eligibleToApplyForTrade = () => includes(tradeStatusesThatCanApplyForTrade, currentUserTradeStatus());

export const setTradeStatusToSuspected = saveTradeStatus(User.TRADE_STATUSES.SUSPECTED);

export function conditionalMarkSuspectedTrade() {
    if (userLoggedIn()) {
        User.load().then(() => {
            if (currentUserTradeStatus() === TRADE_STATUSES.N_A) {
                setTradeStatusToSuspected();
            }
        });
    }
}

export function currentUserCreatedDate() {
    if (userLoggedIn()) {
        const timeStamp = currentUser().get('createdDate');
        return timeStamp ? new Date(timeStamp) : null;
    }

    return null;
}

export function currentUserEmail() {
    if (userLoggedIn()) {
        return currentUser().get('profile.email');
    }

    return null;
}

export function currentUserID() {
    if (userLoggedIn()) {
        return User.getUserId();
    }

    return null;
}

export const setTradeStatusToApplied = saveTradeStatus(User.TRADE_STATUSES.APPLIED_IN_REVIEW);

export function setUserName(firstName, lastName) {
    if (userLoggedIn()) {
        const fullName = `${firstName} ${lastName}`;
        currentUser().get('profile').setDisplayName(fullName).save();
    }
};

export function setUserZipCode(zipCode) {
    if (userLoggedIn()) {
        const user = currentUser();
        user.set('profile.zipCode', zipCode);
        user.get('profile').save();
    }
};

export function userJustRegistered() {
    return currentUser().get('newUser');
};

export function whenUserAuthenticated(callback) {
    if (userLoggedIn()) {
        callback();
    } else {
        currentUser().on('login:change', () => {
            User.load().then(() => {
                if (userLoggedIn()) {
                    callback();
                }
            });
        });
    }
};

export function whenUserFullyLoaded(cb) {
    User.load().then(cb);
};



// WEBPACK FOOTER //
// ./assets/js/postAuth/userHelpers.es.js